var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_1574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3574 11.996H12.7329C14.452 11.996 15.8586 11.083 15.8586 9.3829C15.8586 7.68284 14.2019 6.8364 12.8579 6.76983C12.58 4.11112 10.6387 2.4939 8.35692 2.4939C6.2002 2.4939 4.81115 3.92515 4.35605 5.34452C2.48064 5.52268 0.855286 6.71607 0.855286 8.67024C0.855286 10.6244 2.54315 11.996 4.6061 11.996H6.35648",
    stroke: "#222222",
    strokeWidth: 1.00189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3582 8.49559L8.35747 6.49487L6.35675 8.49559",
    stroke: "#222222",
    strokeWidth: 1.00189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35759 14.5096V6.99487",
    stroke: "#222222",
    strokeWidth: 1.00189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_1574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.0035,
    height: 16.0035,
    fill: "white",
    transform: "translate(0.355713 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.0128bc240cc02940bd0efea87add37c8.svg";
export { ForwardRef as ReactComponent };